{
	"title": "Categoriepagina",
	"breadcrumbs": "Kruimelpad",
	"count_one": "{{count}} product",
	"count_other": "{{count}} producten",
	"resultsFor": "voor “{{search}}”",
	"clearSearch": "Zoekterm wissen",
	"sort": {
		"label": "Sorteer",
		"popular": "Populair",
		"price": "Prijs",
		"pricePerPiece": "Prijs per stuk"
	},
	"filters": {
		"title": "Filters",
		"open": "Filteren",
		"openWithCount": "Filteren ({{count}})",
		"fits": "Past op",
		"groups": "Categorie",
		"allGroups": "Alle producten",
		"availability": "Beschikbaar",
		"inStock": "Alleen op voorraad",
		"count_one": "{{count}} product",
		"count_other": "{{count}} producten",
		"active": "Gekozen filters",
		"remove": "Filter {{name}} weghalen",
		"fitsChip": "Past op {{name}}",
		"inStockChip": "Op voorraad",
		"clear": "Wis alles",
		"show_one": "Toon {{count}} product",
		"show_other": "Toon {{count}} producten",
		"close": "Sluiten"
	},
	"holder": {
		"remembered": "Je houder: {{name}}.",
		"showFitting": "Toon wat past"
	},
	"empty": {
		"searchTitle": "Niets gevonden voor “{{search}}”",
		"searchText": "Probeer een ander woord, of een maat zoals 46×27.",
		"filtersTitle": "Geen producten met deze filters",
		"combination": "Er is geen {{combination}}. Haal een filter weg of wis ze allemaal.",
		"filtersText": "Haal een filter weg of wis ze allemaal.",
		"or": "of",
		"in": "in",
		"clearAll": "Wis alle filters",
		"groupTitle": "In deze categorie staat nog niets",
		"catalogTitle": "Het assortiment staat er nog niet op",
		"text": "Kom snel terug, of bekijk wat er al is.",
		"toAssortment": "Bekijk het hele assortiment"
	},
	"pagination": {
		"label": "Pagina's",
		"previous": "Vorige",
		"next": "Volgende",
		"page": "Pagina {{page}} van {{pages}}"
	}
}
